/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@import url(https://fonts.googleapis.com/css?family=Open+Sans:400,600,700,800&display=swap);input[_ngcontent-%COMP%], label[_ngcontent-%COMP%], select[_ngcontent-%COMP%]{color:#696969;font-size:.8rem}select.form-control[_ngcontent-%COMP%]{border-color:#eceff4}input.form-control[_ngcontent-%COMP%]{min-height:0;background-color:#fff}"];
export { styles as styles };
